/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipExtensionsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('extensions');
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/extensions
  get() {
    return axios.get(this.url);
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/extensions/:id
  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  // POST /api/v1/accounts/:account_id/whatsapp_sip/extensions
  create(data) {
    return axios.post(this.url, data);
  }

  // PUT /api/v1/accounts/:account_id/whatsapp_sip/extensions/:id
  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/whatsapp_sip/extensions/:id
  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }
}

export default new WhatsAppSipExtensionsAPI();
